import {gql} from '@apollo/client';

export const mediaFileQueries = {
    GET_ALL_MEDIA_FIELDS: gql`
        query GetMediaFiles($where: MediaFileFilterInput) {
            mediaFiles(where: $where) {
                id
                userId
                title
                description
                uniqueId
                objectId
                objectType
                fileName
                partialFilePath
                fullUrl
                status
                fileGuidName
                sizeInKbs
                fileExtension
                mimeType
            }
        }
    `,
};
